import { showErrorMessage } from '../../../components/message-boxes/ErrorMessage';
import { getUserError } from '../../../components/miscUtils';
import { TpDataContext } from '../../../data/interfaces';
import { TpDashboardContext } from '../dashboard/interfaces';
import { jsonReplaceDbActionVariables } from './helpers/jsonReplaceVariables';
import { TpDashboardActionContext, TpDbActionVar } from './interfaces';
import { stepDefinitionMap } from './steps-definitions/stepsFactory';

function executeCurrentStep(ctx: TpDashboardActionContext) {
  if (ctx.currentStepNr >= ctx.actionDef.steps.length) return;
  let currentStep = ctx.actionDef.steps[ctx.currentStepNr];

  currentStep = jsonReplaceDbActionVariables(ctx, currentStep);

  const stepDef = stepDefinitionMap[currentStep.type];
  if (!stepDef) throw getUserError(`Invalid dashboard action step type ${currentStep.type}`);
  stepDef.execute(ctx, currentStep, () => {
    executeCurrentStep({
      ...ctx,
      currentStepNr: ctx.currentStepNr + 1,
    });
  });
}

function executeDashboardAction(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  actionDef: any,
  dispatch: any,
  inputVariables: { [id: string]: TpDbActionVar },
) {
  const actionContext: TpDashboardActionContext = {
    dataContext,
    dashboardContext,
    actionDef,
    dispatch,
    currentStepNr: 0,
    variables: inputVariables,
  };
  try {
    executeCurrentStep(actionContext);
  } catch (error: any) {
    if (error.userError) return showErrorMessage(error.message);
    else throw error;
  }
}

export default executeDashboardAction;
